export function isDevMode(): boolean {
    return !isProdMode();
}

export function isProdMode(): boolean {
    return import.meta.env.PROD;
}

export function isExternalProductGuide(): boolean {
    return window.servercontext.isExternalProductGuide;
}
